/** Shared customer-facing proposal visual tokens (Retail + Project). */
export const PROPOSAL_BG = "#FAFAF7";
export const PROPOSAL_TEXT = "#1A2744";
export const PROPOSAL_ACCENT = "#C8A96A";
export const PROPOSAL_COPY_FONT =
  '"Helvetica Neue", "HelveticaNeue-Light", Helvetica, Arial, sans-serif';

export const proposalMoney = new Intl.NumberFormat("en-SG", {
  style: "currency",
  currency: "SGD",
});

export function proposalMoneyText(amount: number): string {
  return formatProposalMoneySafe(amount);
}

/** Never renders $NaN — coerces non-finite values to $0.00. */
export function formatProposalMoneySafe(amount: unknown): string {
  const n = typeof amount === "number" ? amount : Number(amount ?? 0);
  return proposalMoney.format(Number.isFinite(n) ? n : 0);
}
